import { gql } from "@apollo/client";
import CiroCard from "../shared/CiroCard";
import classNames from "classnames";
import CiroOrgContactCellInfo from "../shared/CiroTable/CiroOrgContactCellInfo";
import {
  AutopilotPreviewContactStep_AutopilotSessionPreviewContactStepFragment,
  CiroOrgContactCellInfo_OrgContactFragmentDoc,
} from "../../__generated__/graphql";
import CiroPill from "../shared/CiroPill";
import { useFragment } from "../../__generated__";

export const AutopilotPreviewContactStep_AutopilotSessionPreviewContactStep = gql`
  fragment AutopilotPreviewContactStep_AutopilotSessionPreviewContactStep on AutopilotSessionSavedContactPreview {
    rationale
    org_contact {
      id
      ...CiroOrgContactCellInfo_OrgContact
    }
    scoringCriteriaResults {
      criterion_fit
    }
  }
`;

const AutopilotPreviewContactStep = ({
  contact,
}: {
  contact: AutopilotPreviewContactStep_AutopilotSessionPreviewContactStepFragment;
}) => {
  const { org_contact, scoringCriteriaResults, rationale } = contact;

  const qualifiedCriteria =
    scoringCriteriaResults?.filter((result) => result.criterion_fit).length ??
    0;

  const cellInfoOrgContact = useFragment(
    CiroOrgContactCellInfo_OrgContactFragmentDoc,
    org_contact,
  );

  return (
    <CiroCard size="small" customClassName={classNames("w-full", "mb-4")}>
      <div
        className={classNames(
          "flex",
          "justify-between",
          "items-center",
          "text-sm",
          "w-full",
        )}
      >
        <div className={classNames("w-1/2", "pr-2")}>
          <CiroOrgContactCellInfo
            orgContact={cellInfoOrgContact}
            showCompanyName={true}
          />
        </div>

        <div
          className={classNames("w-1/2", "flex", "flex-col", "gap-2", "h-16")}
        >
          <CiroPill background="bg-orange-100" fontColor="text-orange-600">
            <span className="text-sm">{qualifiedCriteria} criteria met</span>
          </CiroPill>

          <div
            className={classNames(
              "text-sm",
              "text-gray-500",
              "ml-1",
              "truncate",
              "w-full",
            )}
          >
            {rationale?.substring(0, 120)}
            {rationale && rationale.length > 120 ? "..." : ""}
          </div>
        </div>
      </div>
    </CiroCard>
  );
};

export default AutopilotPreviewContactStep;
